import { render } from "./TipMatchRadar.vue?vue&type=template&id=9a94ffa2&scoped=true"
import script from "./TipMatchRadar.vue?vue&type=script&lang=js"
export * from "./TipMatchRadar.vue?vue&type=script&lang=js"

import "./TipMatchRadar.vue?vue&type=style&index=0&id=9a94ffa2&scoped=true&lang=scss"

import exportComponent from "/Users/cp/Code/betslip/BetslipPortal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a94ffa2"]])

export default __exports__